module.exports = __webpack_public_path__ + "media/assets/icons/upload logo-783ec83058b3f043a1516af856142232.svg";